// dependencies
import React from "react";

// icons
import { FaLocationDot } from "react-icons/fa6";

// styles
import styles from "./css/EducationCard.module.css";



export default function EducationCard({ imageSrc, date, header, text, location, isPrimary, onClick}) {

    return (
        // background
        <div className={isPrimary ? styles.card1 : styles.card2} onClick={onClick}>
            <div className={styles.imgContainer}> 
                <img src={imageSrc} alt="education-coorporation" className={isPrimary ? styles.img1 : styles.img2} />
                <div className={isPrimary ? styles.date1 : styles.date2}>{date}</div>
            </div>
            <div className={styles.textContainer}>
                <div className={styles.headerText}>
                    {header}
                </div>
                <div className={styles.text} style={{color: isPrimary ? "#92c4fc" : "#d9b5ff"}}>
                    {text}
                </div>
                <div className={styles.location}>
                    <div className={styles.locationIcon}><FaLocationDot /></div>
                    <div className={styles.locationText}>{location}</div>
                </div>
            </div>
        </div>
    );
}
